import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

/**
 * Fases 8, 9 y 11 — wrappers de servicio: edición de turnos por día, marcaje
 * de turno y metas de ventas.
 */
class StaffAdvancedService {
  /** Fase 8 — CRUD de turno puntual por día (manualOverride=true) */
  async setShiftForDate(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-setShiftForDate');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 9 — Marcaje de turno ('in' | 'out'). targetStaffId opcional. */
  async clockInOut(restaurantId, action, targetStaffId) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-clockInOut');
    const res = await fn({ restaurantId, action, targetStaffId });
    return res.data;
  }

  /** Fase 11 — Setear / ajustar / borrar meta mensual de ventas. */
  async manageSalesGoal(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-manageSalesGoal');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 10 — Cuentas del staff: consumption / settle / adjust / remove. */
  async manageStaffAccount(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-manageStaffAccount');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 10 — Aplica un descuento % a un bill atribuido a un staff. */
  async applyStaffDiscountToBill(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-applyStaffDiscountToBill');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 10b — Asociación bill→staff con descuento + split (full/partial/none). */
  async associateBillToStaff(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-associateBillToStaff');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 12 — Plantillas de evaluación: create/update/archive/duplicate/seed. */
  async manageEvaluationTemplate(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-manageEvaluationTemplate');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 12 — Metas flexibles: create/update/setProgress/close/delete. */
  async manageStaffGoal(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-manageStaffGoal');
    const res = await fn(payload);
    return res.data;
  }

  /** Fase 10 — Balance financiero del staff (salario + tips - deuda). */
  async getStaffFinancialBalance(payload) {
    const fn = httpsCallable(functions, 'restaurants-endpoints-getStaffFinancialBalance');
    const res = await fn(payload);
    return res.data;
  }

  /** Confirmación de llegada — confirmar/rechazar la solicitud de clock-in. */
  async resolveClockInRequest(payload) {
    // { restaurantId, shiftRecordId, decision: 'confirm'|'reject', reason? }
    const fn = httpsCallable(functions, 'restaurants-endpoints-resolveClockInRequest');
    const res = await fn(payload);
    return res.data;
  }

  /** Solicitudes de turno/ausencia — aprobar/rechazar desde el calendario. */
  async resolveShiftRequest(payload) {
    // { restaurantId, requestId, action: 'approve'|'reject', resolutionNote?, shiftTemplateId? }
    const fn = httpsCallable(functions, 'restaurants-endpoints-resolveShiftRequest');
    const res = await fn(payload);
    return res.data;
  }
}

export const staffAdvancedService = new StaffAdvancedService();
export default staffAdvancedService;
